// Payments API — wraps /payments/* endpoints (ported from pricing.js).
// Auth header is injected by the shared client. Contracts verified against
// http_api/router.py (/payments/plans, /intro, /create-link, /status/{id}).

import { api } from './client'
import type {
  PlansResponse,
} from '../types/api'

interface IntroResponse {
  intro_text?: string | null
}
interface CreateLinkResponse {
  payment_url?: string
}

export const paymentsApi = {
  plans: () => api.get<PlansResponse>('/payments/plans'),
  intro: () => api.get<IntroResponse>('/payments/intro').catch(() => null),
  createLink: (planId: string) => api.post<CreateLinkResponse>('/payments/create-link', { plan_id: planId }),
  status: (orderId: string) => api.get(`/payments/status/${orderId}`),
  cancel: () => api.post<{ active_until?: string }>('/payments/cancel'),
}

export type PaymentsApi = typeof paymentsApi
